import $ from "../$.js";
import * as Html from "./Html.ts";
import * as amplify from "./amplify.ts";
import * as i18n from "../i18n.ts";
import * as TPL_snack from "../modal/snack.mustache";
import Icons, { SvgFile } from "../svg/Icons.ts";
import { ArrayQueue } from "../lib/ArrayQueue.ts";

//TODO use this
export type Modal = JQuery&{amplifyEvents:namedFunctions,onClose:modalMethod,onConfirm:modalMethod}
type modalMethod = (this:Modal,arg?:any)=>void;


var
  popups = [],
  snacks = [];

export function openModal(name :MUS,data :any,amplifyEvents = {}){
  var modal :Modal,
    body = $(document.body);
   
  
  modal = Html.setHtmlAtEnd(body,name,data) as Modal;
  modal.get(0).scrollIntoView(false);
  popups.push(modal);
  
  modal.amplifyEvents = amplifyEvents;
  for(var i in modal.amplifyEvents){
    amplify.subscribe(i,modal.amplifyEvents[i]);
  }
  
  return modal;
}
type ToastInput = {
  svg?:SvgFile,
  icon?:SvgFile,
  emoji?:string,
  text:string,
  onclick?:()=>any
  button?:Array<{title:string,onclick:()=>any}>
}
type ToastOutput = {
  node:JQuery,
  close:()=>void,
  closed:Promise<void>
}

const DISPLAYED_TOASTS = new ArrayQueue<ToastOutput>()
export async function toast(data :ToastInput, autoclose ?:number|undefined ){
  if(autoclose===undefined){
    autoclose = data.button?6000:3000
  }
  let 
    TPL = await import("../modal/toast_simple.mustache"),
    node = Html.setHtmlAtEnd($(document.body),TPL,data),
    resolveClose : (value:void)=>void,
    closed = new Promise<void>((resolve,reject)=>resolveClose=resolve),
    output = {node,closed,close},
    closeTimer :number;
    
  var index = DISPLAYED_TOASTS.push(output);
  node.css('bottom',(7*(index+1)-2)+'%');  
  
  function slowClose(){
    node.addClass('fadeOutDown');
    closeTimer = setTimeout(close,1000)
  }
  
  function close(){
    clearTimeout(closeTimer)
    Html.cleanHtml(node);
    node.remove();
    DISPLAYED_TOASTS.remove(output);
    resolveClose();
  }
  node.on('click',close)
  if(data.onclick) {
    node.find('flexauto').on('click',data.onclick)
  }
  if(data.button){
    data.button.forEach((button,idx)=>{
      $(node.find('a').get(idx)).on('click',button.onclick)
    })
  }
  if(autoclose!==0){
    closeTimer = setTimeout(slowClose,autoclose)
  }
  return output;
  
}
export function toastDone(i18nKey :string,data :any,toastOptions :any){
  return toast(Object.assign({text:i18n.get(i18nKey,data),svg:Icons.ic_done},toastOptions))
}
export function closeModal(modal ?){
  if(modal==undefined && popups.length>0){
    modal = popups[popups.length-1];
  }
  if(modal==undefined) return;
  if(popups.indexOf(modal)>-1){
    popups.splice(popups.indexOf(modal),1);
  }
  Html.cleanHtml(modal);
  modal.remove();
  for(var i in modal.amplifyEvents){
    amplify.unsubscribe(i,modal.amplifyEvents[i]);
  }
  if(modal.onClose){
    modal.onClose();
  }
    
  
}
export function updateModal(node,name :MUS,data :any){
  //if no node or node not attached to document (if node stored but cleaned by a closeModal)
  if(!node || !node.parents().length){
    return openModal(name,data)
  }else{
    var newNode = Html.replaceWith(node,name,data) as Modal;
    popups.splice(popups.indexOf(node),1,newNode)
    newNode.amplifyEvents = node.amplifyEvents;
    return newNode;
  }
}
export function closeSnack(){
  $('.fw-snack').each(function(idx,snack){
    $(snack).css('opacity',0);
    snacks.forEach(snack=>snack.onClose())
    setTimeout(function(){$(snack).remove()},500)
  });
}
Html.register({
  modalclose(after:string){
    closeModal();
    if(after){
      Html.trigger(this,after,Array.prototype.slice.call(arguments,1));
    }
  },
  snackclose:closeSnack,
  modalconfirm(result){
    popups[popups.length-1].onConfirm(result);
    closeModal();
  },
  modalanswer(answer){
    if(typeof answer === 'string' && answer.length===0){
      answer = null;
    }
    let popup = popups[popups.length-1];
    popup.onConfirm(answer);
    closeModal(popup);
    
  }
});

/*
  Function: openDialog(type,message,onConfirm): object
  Open a modal dialog with given title, message and optional callbacks

  Parameters:
    type - string, the name of the mustache modal for the dialog,
      one of the constants OK, OK_CANCEL or YES_NO
    message - string, the text to display as message in the modal
    onConfirm - function, optional, callback called when the modal is closed
      with the confirm button

  Returns:
    object, jQuery object wrapping the new dialog
*/
function openDialog(tpl :MUS, message:any, onConfirm?:modalMethod, onClose ?:modalMethod){
  var modal = openModal(tpl,(typeof message === 'string')?{ message: message}:message);
  modal.onConfirm = onConfirm || $.noop;
  modal.onClose = onClose;
  return modal;
}


export function oops(message :SimpleInput|string,onConfirm?:modalMethod){
  var simpleArg = {title:'errors.oops',lottie:"images/lottie/dizzy_face.json",button:"actions.ok",message:undefined};
  if(typeof message === 'object'){
    Object.assign(simpleArg,message)
  }else{
    simpleArg.message = message;
  }
  simple(simpleArg,onConfirm)
}


type ConfirmInput = {
  title:string,
  message:string,
  yes:string,
  no:string,
  lottie:string
}

export async function confirm(message :Partial<ConfirmInput>|string){
  var data :Partial<ConfirmInput> = {
    title:'new_confirm_action.title',
    yes:'actions.yes',
    no:'actions.no',
    message:''
  };
  if((typeof message === 'string')){
    data.message = message;
  }else{
    Object.assign(data,message);
  }
  return askAsPromise({
    title:data.title,
    message:data.message,
    lottie:data.lottie,
    button:[
      {title:data.yes,value:'true'},
      {title:data.no,value:'false',class:"negative"},
    ]
  }).then(value=>{
    return value==='true'
  })
}
export async function confirmDelete(message :string |Partial<ConfirmInput>,onConfirm?:Function){
  var data :Partial<ConfirmInput> = {
    title:'new_confirm_action.title',
    yes:'actions.yes',
    no:'actions.no',
    lottie:'images/lottie/anim_warning.json'
  };
  if((typeof message === 'string')){
    data.message = message;
  }else{
    Object.assign(data,message);
  }
  return askAsPromise({
    title:data.title,
    messageHTML:i18n.get(data.message),
    lottie:data.lottie,
    button:[
      {title:data.yes,value:'true',class:"negative"},
      {title:data.no,value:'false',class:"secondary"},
    ]
  }).then(value=>{
    if(onConfirm && value==='true'){
      onConfirm()
    }
    return value==='true'
  })
  
}

type AskInput = {
  title?:string,
  message?:string,
  messageHTML?:string,
  lottie?:string,
  mediaSize?:string,
  button:Array<{title:string,class?:"negative"|"secondary",action?:string,value?:any,onclick?:()=>any}>
}

export async function ask(data :AskInput,onConfirm?:modalMethod){
  if(onConfirm===undefined){
    for(let i=0;i<data.button.length;i++){
      data.button[i].value = ""+i;
    }
    onConfirm = function(clicked){
      for(let i=0;i<data.button.length;i++){
        if(clicked===data.button[i].value){
          if(data.button[i].onclick) {
            data.button[i].onclick(); 
          }
          return;
        }
      }
    }
  }
  var TPL = await import("../modal/dialog_ask.mustache")
  return openDialog(TPL,data,function(arg){
    onConfirm.call(this,arg);
    this.onClose=undefined
  },function(){
    onConfirm.call(this,null)
  });

}

export async function askAsPromise(data :AskInput){
  var tpl = await import("../modal/dialog_ask.mustache");
  
  return new Promise((resolve,reject)=>{
    openDialog(tpl,data,function(arg){resolve(arg);this.onClose=undefined},function(){
      resolve(null)
    });
  });
}

export async function askAsPromiseTpl(tpl :MUS|undefined ,data :any){
  return new Promise((resolve,reject)=>{
    openDialog(tpl,data,function(arg){resolve(arg);this.onClose=undefined},function(){
      resolve(null)
    });
  });
}


type PickButton = {
  title?:string,
  text?:string,
  icon?:SvgFile
  image?:string
}

type PickInput<T extends PickButton> = {
  title:string
  cssClass?:"large"
  button :T[]
}

export async function pick<T>(data :PickInput<T>) :Promise<T>{
  var TPL = await import("../modal/dialog_pick.mustache")
  return new Promise((resolve,reject)=>{
    openDialog(TPL,data,function(arg){
      resolve(data.button[arg]);
      this.onClose=undefined
    },function(){
      resolve(null)
    });
  });
}


type SimpleInput = {
  title?:string
  lottie?:string
  message:string
  button?:string
}

export function simple(messageObject :SimpleInput,onConfirm?:modalMethod,onClose?:modalMethod){
  import("../modal/dialog_simple.mustache").then(function(tpl){
    openDialog(tpl,messageObject,onConfirm,onClose);
  });
}

document.addEventListener('keyup', function ( e :KeyboardEvent ) {
  if(e.which===27){
    closeModal();
  }
});
amplify.subscribe("pageUnload",function(){
  while(popups.length>0){
    closeModal();
  }
});

export async function alert(message :string|AskInput,onConfirm? :Function){
  var datas :AskInput = {
    button:[
      {title:"actions.ok"},
    ]
  };
  if((typeof message === 'string')){
    datas.message = message;
  }else{
    Object.assign(datas,message);
  }
  return askAsPromise(datas).then(value=>{
    //TODO remove this when all alert call will be done with an await
    if(onConfirm){
      onConfirm()
    }
  })
  
}
/**
 * Use only in specific case when we need the modal Node, prefer simple modal.alert()
 * @param message 
 * @returns the modal 
 */
export async function alertModal(message :string|AskInput){
  var datas :AskInput = {
    button:[
      {title:"actions.ok"},
    ]
  };
  if((typeof message === 'string')){
    datas.message = message;
  }else{
    Object.assign(datas,message);
  }
  return openDialog(await import("../modal/dialog_ask.mustache"),datas)
}



export function snack(TPL :MUS,data :any,displayTime = 0){
  var 
    snackNode = Html.setHtmlAtEnd($('.fw-layout'),TPL,data),
    theSnack = {node:snackNode,onClose:()=>{}};
  setTimeout(function(){snackNode.css('opacity',1)},100)
  snacks.push(theSnack)
  if(displayTime){
    setTimeout(function(){closeSnack()},displayTime);  
  }
  return theSnack;
}
export function snackDone(key :string){
  return snack(TPL_snack,{key:key},2000)
}

type AskURLInput = {
  title:string,
  lottie?:string,
  image?:string,
  message:string,
  placeholder:string,
  sub?:string,
  buttonName:string,
  validate:(url:string)=>Promise<boolean>
}

export async function askUrl(options :AskURLInput){
  return new Promise<string>(async (resolve,reject)=>{
    var 
      url :string,
      TPL = await import("../modal/calbyurl.mustache")
    var theModal = openModal(TPL,options);
    theModal.find('form').on('submit',async function(this:HTMLFormElement){
      if(!this.url.value) return;
      var isValid = await options.validate(this.url.value)
      if(isValid){
        url = this.url.value;
        closeModal(theModal);
      }else{
        url = undefined;
      }
    })
    theModal.onClose = ()=>resolve(url)
  })
}